import { SanityBlock } from '@dtp/membership-service-types/dist/sanity/sanity';
import { PortableTextBlock } from '@portabletext/react';
import { LinkType } from '../../../../types/LinkType';

// Compare component.
export enum ExpandableMembershipBoxVariant {
  Dew = 'Dugg',
  Outline = 'Outline',
}

export interface Product {
  productNumber: string;
  productName: string;
  productAppPrice?: Record<string, { itemCount: number; itemTotalPrice: number }>;
}

export interface ProductPriceItem {
  itemCount: number;
  itemTotalPrice: number;
}

export interface HouseholdPrice {
  title: string;
  price: string;
}

export interface ExpandableMembershipBoxProps {
  tag?: boolean;
  title?: string;
  variant?: ExpandableMembershipBoxVariant;
  openByDefaultOnDesktop?: boolean;
  showPriceInline?: boolean;
  terms?: PortableTextBlock[];
  householdMembers?: boolean;
  benefitAccordions?: any[];
  cta?: LinkType;
  product?: Product;
  productPrice?: string;
  householdPrices?: HouseholdPrice[];
  isMobile?: boolean;
}

// Accordion component
export interface MembershipBoxAccordionProps {
  title?: string;
  variant?: MembershipAccordionVariant;
  content?: SanityBlock[];
  showIcon?: boolean;
  noBackground?: boolean;
  onExpand?: () => void;
}

export enum MembershipAccordionVariant {
  Available = 'Available',
  Unavailable = 'Unavailable',
}

// Price listing accordion.
export interface Price {
  title?: string; // E.g., "1 Person", "2 Personer"
  price?: string;
}

export interface HouseholdMembershipPriceAccordionProps {
  title?: string;
  prices?: Price[];
  terms?: PortableTextBlock[];
}
